import React from "react";
import moment from "moment";

import numberFormatter from "../../utils/numberFormatter";

import { CellContentWrapper, ButtonWrapper, Link } from "./dashboard.style";
import SelectFilter from "./SelectFilter";
import DateFilter from "./DateFilter";

const isFloat = inputString => {
  const parsed = parseFloat(inputString);

  return !isNaN(parsed) && parsed.toString() === inputString.toString();
};

export const columns = (goToDeal, isDiscountDataVisible) => {
  const columns = [
    { Header: "Deal Name",
      accessor: "dealName",
      Cell: item => (
        <ButtonWrapper>
          <Link onClick={() => goToDeal(item.row.original.dealId, item.row.original.loanId)}>{item.row.values.dealName}</Link>
        </ButtonWrapper>
      ) }
  ];

  if (isDiscountDataVisible) {
    columns.push({ Header: "Risk Free Rate",
      accessor: "riskFreeRate",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {numberFormatter.formatRate(item.value, 2)}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Discount Rate",
      accessor: "discountRate",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {numberFormatter.formatRate(item.value, 2)}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Lender",
      accessor: "lender",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {item.value}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Debt Value",
      accessor: "debtValue",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {numberFormatter.formatMoney(item.value, 0)}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Premium or Discount",
      accessor: "premiumOrDiscount",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {numberFormatter.formatMoney(item.value, 0)}
        {" "}
                     </CellContentWrapper>) });
  } else {
    columns.push({ Header: "Property Value",
      accessor: "propertyValue",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {numberFormatter.formatMoney(item.value, 0)}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Loan Balance",
      accessor: "loanBalance",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {numberFormatter.formatMoney(item.value, 0)}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Calculation LTV",
      accessor: "calculationLTV",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {numberFormatter.formatRate(item.value, 2)}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Maturity Date", accessor: "maturityDate", sortType: "basic", Filter: DateFilter, filter: "dateBetween", Cell: item => (<CellContentWrapper>{moment(item.value).format("MM/DD/YYYY")}</CellContentWrapper>) });
    columns.push({ Header: "Note Rate",
      accessor: "noteRate",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {isFloat(item.value) ? numberFormatter.formatRate(item.value, 2) : item.value}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Rate Type",
      accessor: "rateType",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {item.value}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Remaining Maturity (Months)",
      accessor: "remainingMaturity",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {item.value}
        {" "}
                     </CellContentWrapper>) });
    columns.push({ Header: "Replacement Spread",
      accessor: "replacementSpread",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {" "}
        {numberFormatter.formatRate(item.value, 2)}
        {" "}
                     </CellContentWrapper>) });
    columns.push({
      Header: "Rates as of",
      accessor: "ratesAsOf",
      sortType: "basic",
      Filter: SelectFilter,
      Cell: item => (<CellContentWrapper>
        {moment(item.value).format("MM/DD/YYYY")}
      </CellContentWrapper>)
    });
  }

  return [
    {
      Header: () => (<></>),
      id: "dv-dashboard-header",
      columns
    }
  ];
};

